import React from 'react';
import Section from './Section';
import { AlertTriangle, Search, DollarSign } from 'lucide-react';

const Problem: React.FC = () => {
  return (
    <Section id="problem" className="bg-neutral-950">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        {/* Intro - Sticky only on Desktop */}
        <div className="relative lg:sticky lg:top-32">
          <h2 className="text-4xl md:text-6xl font-display text-white mb-6 md:mb-8 leading-[0.9]">
            PRECISION<br />
            IS PATIENCE.
          </h2>
          <p className="text-neutral-400 text-base md:text-lg mb-8 leading-relaxed font-light max-w-md">
            Lak is kwetsbaar. De meeste imperfecties ontstaan niet tijdens het rijden, maar tijdens onzorgvuldig onderhoud.
          </p>
          <div className="h-px w-20 bg-white/20"></div>
        </div>

        {/* Points list */}
        <div className="grid gap-12 md:gap-16">
          <div className="group">
            <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-6 mb-3 md:mb-4">
              <span className="text-4xl md:text-5xl font-display text-neutral-800 group-hover:text-white transition-colors duration-500">01</span>
              <h3 className="text-xl md:text-2xl text-white font-display">De Zwakke Plek</h3>
            </div>
            <p className="text-neutral-500 text-sm leading-7 md:pl-[4.5rem] border-l-0 md:border-l border-white/10 group-hover:border-white/30 transition-colors">
              Geautomatiseerde wasstraten en sponsen houden vuil vast dat werkt als schuurpapier. 
              Het resultaat: miljoenen micro-krasjes (swirls) die de glans breken en de kleur dof maken.
            </p>
          </div>

          <div className="group">
            <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-6 mb-3 md:mb-4">
              <span className="text-4xl md:text-5xl font-display text-neutral-800 group-hover:text-white transition-colors duration-500">02</span>
              <h3 className="text-xl md:text-2xl text-white font-display">Waarde & Behoud</h3>
            </div>
            <p className="text-neutral-500 text-sm leading-7 md:pl-[4.5rem] border-l-0 md:border-l border-white/10 group-hover:border-white/30 transition-colors">
              Een auto in fabrieksstaat behoudt zijn waarde aanzienlijk beter. 
              Wij maskeren geen defecten met fillers, maar corrigeren de laklaag permanent.
            </p>
          </div>
          
          <div className="group">
             <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-6 mb-3 md:mb-4">
              <span className="text-4xl md:text-5xl font-display text-neutral-800 group-hover:text-white transition-colors duration-500">03</span>
              <h3 className="text-xl md:text-2xl text-white font-display">Onze Standaard</h3>
            </div>
            <p className="text-neutral-500 text-sm leading-7 md:pl-[4.5rem] border-l-0 md:border-l border-white/10 group-hover:border-white/30 transition-colors">
              Inspectie onder kleurecht spectrumverlichting. Meten van lakdikte. Gebruik van de zuiverste coatings. 
              Wij nemen de tijd die nodig is, niet de tijd die over is.
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Problem;